<template>
  <b-modal
    v-model="showModal"
    title="Special Bonus Details"
    size="lg"
    @hidden="$emit('modal-closed')"
  >
    <b-alert
      variant="danger"
      :show="errorMessage ? true : false"
    >
      <div
        v-if="typeof errorMessage === 'object'"
        class="alert-body"
      >
        <p
          v-for="(message, index) in errorMessage"
          :key="index"
        >
          {{ message }}
        </p>
      </div>
      <p
        v-else
        class="alert-body"
      >
        {{ errorMessage }}
      </p>
    </b-alert>

    <div
      v-if="loading"
      class="text-center"
    >
      <b-spinner
        label="Small Spinner"
        variant="primary"
      />
    </div>
    <div v-if="!loading && !errorMessage">
      <!-- Basic Bonus Information -->
      <b-table-simple
        responsive
        hover
        class="mb-2"
      >
        <b-tbody>
          <b-tr>
            <b-th style="width: 20%;">
              Product:
            </b-th>
            <b-td colspan="3">
              {{ details.product_name }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th>Status:</b-th>
            <b-td style="width: 30%;">
              <app-chip :variant="details.is_active ? 'success' : 'danger'">
                {{ details.is_active ? 'Active' : 'Inactive' }}
              </app-chip>
            </b-td>
            <b-th style="width: 20%;">
              Bonus Type:
            </b-th>
            <b-td style="width: 30%;">
              {{ details.bonus_type && details.bonus_type.charAt(0).toUpperCase() + details.bonus_type.slice(1) }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th>Start Date:</b-th>
            <b-td>{{ details.start_date || '-' }}</b-td>
            <b-th>End Date:</b-th>
            <b-td>{{ details.end_date || '-' }}</b-td>
          </b-tr>
          <b-tr>
            <b-th>Created At:</b-th>
            <b-td colspan="3">
              {{ details.created_at && formatedDate(details.created_at, 'DD-MM-YYYY LT') || '-' }}
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <!-- ERP Products -->
      <div
        v-if="details.erp_products && details.erp_products.length > 0"
        class="mb-2"
      >
        <h5>ERP Products (Batches)</h5>
        <b-table-simple
          responsive
          hover
        >
          <b-thead>
            <b-tr>
              <b-th>Batch Number</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr
              v-for="(product, index) in details.erp_products"
              :key="index"
            >
              <b-td>{{ product.batch }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>

      <!-- Lot Type Details -->
      <div
        v-if="details.bonus_type === 'lot' && details.lots && details.lots.length > 0"
        class="mb-2"
      >
        <h5>Lot Details</h5>
        <b-table-simple
          responsive
          hover
        >
          <b-thead>
            <b-tr>
              <b-th>Quantity</b-th>
              <b-th>Free Quantity</b-th>
              <b-th>Lot String</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr
              v-for="(lot, index) in details.lots"
              :key="index"
            >
              <b-td>{{ parseLot(lot.lot).quantity }}</b-td>
              <b-td>{{ parseLot(lot.lot).freeQuantity }}</b-td>
              <b-td>{{ lot.lot }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>

      <!-- Rate Type Details -->
      <div
        v-if="details.bonus_type === 'rate' && details.rates && details.rates.length > 0"
        class="mb-2"
      >
        <h5>Rate Details</h5>
        <b-table-simple
          responsive
          hover
        >
          <b-thead>
            <b-tr>
              <b-th>Minimum Quantity</b-th>
              <b-th>Rate</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr
              v-for="(rate, index) in details.rates"
              :key="index"
            >
              <b-td>{{ rate.min_quantity }}</b-td>
              <b-td>₹{{ parseFloat(rate.rate).toFixed(2) }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>

      <!-- Gift Type Details -->
      <div
        v-if="details.bonus_type === 'gift' && details.gifts && details.gifts.length > 0"
        class="mb-2"
      >
        <h5>Gift Details</h5>
        <div
          v-for="(gift, index) in details.gifts"
          :key="index"
          class="mb-2"
        >
          <b-table-simple
            responsive
            hover
            class="mb-2"
          >
            <b-tbody>
              <b-tr>
                <b-th>Gift Name:</b-th>
                <b-td>{{ gift.name }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Description:</b-th>
                <b-td>{{ gift.description }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Eligibility On:</b-th>
                <b-td>
                  {{ gift.eligibility_type.charAt(0).toUpperCase() + gift.eligibility_type.slice(1) }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th>{{ gift.eligibility_type === 'quantity' ? 'Minimum Quantity:' : 'Minimum Amount:' }}</b-th>
                <b-td>
                  <span v-if="gift.eligibility_type === 'quantity'">
                    <span v-if="gift.min_quantity">{{ gift.min_quantity }}</span>
                    <span v-if="gift.min_quantity_2">, {{ gift.min_quantity_2 }}</span>
                    <span v-if="gift.min_quantity_3">, {{ gift.min_quantity_3 }}</span>
                    <span v-if="gift.min_quantity_4">, {{ gift.min_quantity_4 }}</span>
                    <span v-if="!gift.min_quantity && !gift.min_quantity_2 && !gift.min_quantity_3 && !gift.min_quantity_4">-</span>
                  </span>
                  <span v-else>
                    ₹{{ gift.min_amount || '-' }}
                  </span>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>

          <!-- Gift Images -->
          <div
            v-if="gift.images && gift.images.length > 0"
            class="mb-2"
          >
            <h6>Gift Images/Files</h6>
            <div class="row">
              <div
                v-for="image in gift.images"
                :key="image.id"
                class="col-md-6 col-lg-4 mb-2"
              >
                <!-- For PDF files -->
                <div
                  v-if="isPdf(image.file)"
                  class="text-center p-3 border"
                >
                  <i
                    class="fas fa-file-pdf text-danger"
                    style="font-size: 2rem;"
                  />
                  <div class="mt-2">
                    <a
                      :href="image.file"
                      target="_blank"
                      class="text-primary"
                    >
                      View PDF File
                    </a>
                  </div>
                </div>

                <!-- For Image files -->
                <div
                  v-else
                  class="text-center"
                >
                  <img
                    :src="image.file"
                    :alt="image.alt_text"
                    class="img-fluid"
                    style="max-height: 200px; border: 1px solid #ddd;"
                    @error="onImageError"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Free Product Type Details -->
      <div
        v-if="details.bonus_type === 'free_product' && details.free_product"
        class="mb-2"
      >
        <h5>Free Product Details</h5>
        <b-table-simple
          responsive
          hover
        >
          <b-tbody>
            <b-tr>
              <b-th style="width: 35%;">
                Free Product Name:
              </b-th>
              <b-td>{{ details.free_product[0].free_product_name || '-' }}</b-td>
            </b-tr>
            <b-tr>
              <b-th>Free Product Code:</b-th>
              <b-td>{{ details.free_product[0].free_product_code || '-' }}</b-td>
            </b-tr>
            <b-tr>
              <b-th>Main Product Quantity:</b-th>
              <b-td>{{ details.free_product[0].main_product_quantity || '-' }}</b-td>
            </b-tr>
            <b-tr>
              <b-th>Free Product Quantity:</b-th>
              <b-td>{{ details.free_product[0].free_product_quantity || '-' }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </div>

    <template #modal-footer="{ ok, cancel }">
      <b-button
        variant="secondary"
        @click="cancel()"
      >
        Close
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BSpinner, BButton, BAlert, BTableSimple, BTr, BTh, BTd, BTbody, BThead,
} from 'bootstrap-vue'
import axios from 'axios'
import dateMixin from '@/mixins/dateMixin'
import AppChip from '../../UI/AppChip.vue'

export default {
  components: {
    BModal,
    BButton,
    BSpinner,
    BAlert,
    BTableSimple,
    BTr,
    BTh,
    AppChip,
    BTd,
    BTbody,
    BThead,
  },
  mixins: [dateMixin],
  props: {
    id: { type: Number, required: true },
  },
  data() {
    return {
      showModal: true,
      details: {},
      loading: true,
      errorMessage: '',
    }
  },
  mounted() {
    this.fetchDetails()
  },
  methods: {
    async fetchDetails() {
      try {
        this.loading = true
        const { data } = await axios.get(`/marg/special-bonus/${this.id}`)
        this.details = data
      } catch (error) {
        this.errorMessage = error?.response?.data?.detail || 'Failed to fetch details'
      } finally {
        this.loading = false
      }
    },
    parseLot(lotString) {
      // Parse "14+8" format where 14 is quantity and 8 is free quantity
      const parts = lotString.split('+')
      return {
        quantity: parts[0] || '0',
        freeQuantity: parts[1] || '0',
      }
    },
    isPdf(fileUrl) {
      // Check if file is PDF based on extension
      const extension = fileUrl.split('.').pop().toLowerCase()
      return extension === 'pdf'
    },
    onImageError(event) {
      // Handle image loading errors
      const { target } = event
      target.src = '/path/to/placeholder-image.jpg' // Add your placeholder image path
    },
  },
}
</script>

<style scoped>
/* Minimal styling for clean appearance */
h5, h6 {
  font-weight: 600;
  margin-bottom: 1rem;
}

.img-fluid {
  border-radius: 4px;
}
</style>
